import { render, staticRenderFns } from "./SubscriptionsEqualPrices.vue?vue&type=template&id=2a2d559a"
import script from "./SubscriptionsEqualPrices.vue?vue&type=script&lang=js"
export * from "./SubscriptionsEqualPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports